import { useMemo } from "react";
import type { TaskSelectionSummary } from "@common/types/task";
import { useTaskSummaries } from "@api/task.api";
import { TaskGlyph } from "./TaskGlyph";
import {
    MAX_ENTITY_REF_OPTIONS,
    NO_ENTITY_REF_OPTIONS,
    type EntityRefOption,
    type EntityRefOptionsParams,
    type EntityRefOptionsResult,
} from "./entityRefOptions.types";

function toTaskOption(task: TaskSelectionSummary): EntityRefOption {
    return {
        key: `task:${task.id}`,
        entityRef: { kind: "task", id: task.id, label: task.name },
        icon: <TaskGlyph />,
        title: task.name,
    };
}

export function useTaskRefOptions({
    query,
    isEnabled,
}: EntityRefOptionsParams): EntityRefOptionsResult {
    const { data: tasks, isLoading } = useTaskSummaries({
        enabled: isEnabled,
    });

    return useMemo(() => {
        if (!isEnabled) {
            return NO_ENTITY_REF_OPTIONS;
        }
        const normalizedQuery = query.trim().toLowerCase();
        const options = (tasks ?? [])
            .filter((task) => task.name.toLowerCase().includes(normalizedQuery))
            .slice(0, MAX_ENTITY_REF_OPTIONS)
            .map(toTaskOption);
        return { options, isLoading };
    }, [isEnabled, tasks, query, isLoading]);
}
